<template>
  <div class="container-cidades">
    
    <div class="row">
        <div class="col-sm-12">
      <h1>Gerenciamento de Bairros </h1><br>
    </div>

    <div class="form-group col-sm-6">
          <label>Busca:</label>
          <input type="text"  class="form-control" value="" v-model="busca">
        </div>
<button  @click="getBairros" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">BUSCAR</button>

<div class=" col-sm-12"></div>

          <div class="form-group col-sm-4">
          <label>Nome do bairro:</label>
          <input type="text" name="bairro" class="form-control" value="" v-model="bairro">
        </div>

          <button v-if="bairroSelecionado == null" @click="addBairro()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">+ADICIONAR</button>
          <button v-if="bairroSelecionado != null" @click="applyUpdates()" type="button" class="btn btn-warning col-sm-2" style="max-height:40px;margin-top:30px;">SALVAR ALTERAÇÕES</button>

        <div class="col-sm-2" v-if="loading" >
          <div class="spinner-border" role="status" style="max-height:40px;margin-top:35px;">
            <span class="sr-only">Loading...</span>
          </div>
        </div>

         <div v-if="bairroSelecionado != null" class="form-group col-sm-12">
          <label>Descrição do Bairro:</label>
          <textarea name="descricao" class="form-control" v-model="descricao"></textarea>
        </div>

    </div><!-- row -->


    <div class="row">

 <table class="col-sm table table-striped table-dark">
  <thead>
    <tr>
     
      <th scope="col">Bairro</th>
       <th scope="col">Editar Descrição</th>
      <th scope="col">Deletar</th>
    </tr>
  </thead>
  <tbody>
    <tr v-for="(item, index ) in bairros" :key="item.BAI_ID" >
     
      <td>
         <input type="text" :data-codigo="item.BAI_ID" name="setBairro" @keyup.enter="updateBairro" class="form-control" :value="item.BAI_NOME">
       </td>
     
       <td><button type="button" :data-codigo="index" class="btn btn-warning" @click="updateDescricao">Editar</button></td>

      <td><button type="button" :data-codigo="item.BAI_ID" class="btn btn-danger" @click="deleteBairro">Deletar</button></td>
    </tr>
   
  </tbody>
</table>

    </div><!-- row table -->



  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Bairro',
  components: {},
  props:['cidade'],
  data(){
      return {
          bairros:[],
          bairro:'',
          descricao:'',
          bairroSelecionado:null,
          loading: false,
          busca:''
      }
  },
 

methods:{
    addBairro(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/novoBairro',{bairro:this.bairro,cidade:this.cidade})
          .then( () => this.getBairros())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.bairro = ''})
      },


    getBairros(){
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/getBairros',{cidade:this.cidade,busca:this.busca})
          .then(response => this.bairros = response.data)
          .catch(response => console.log(response))
          .finally(() =>  this.loading = false)
    },

    updateBairro(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/setBairro',{bairro:event.target.value,id:codigo})
          .then( () =>  this.getBairros())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    },

      updateDescricao(event){
          let index = event.target.dataset.codigo
          this.bairroSelecionado = this.bairros[index];
          this.descricao = this.bairroSelecionado.BAI_DESCRICAO;
          this.bairro = this.bairroSelecionado.BAI_NOME;
          window.scrollTo(0,0);
    },

     applyUpdates(){
          this.loading = true;
          this.bairroSelecionado.BAI_NOME = this.bairro;
          this.bairroSelecionado.BAI_DESCRICAO = this.descricao;
       
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/atualizarBairro',this.bairroSelecionado)
          .then( () => this.getBairros())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;this.bairro = '',this.descricao = '',this.bairroSelecionado = null;alert("Alterações feitas com sucesso!");})
      },

    deleteBairro(event){
          let codigo = event.target.dataset.codigo
          this.loading = true;
          axios
          .post('https://www2.royaljardim.com.br/sistema/welcome/deleteBairro',{id:codigo})
          .then( () =>  this.getBairros())
          .catch(response => console.log(response))
          .finally(() =>  {this.loading = false;})
    }

},
  
  mounted () {
  this.getBairros();
  }



}
</script>